import { AbstractApi } from '../abstract-api';
import {
  RoleApi,
  ManageApi,
  ResourceApi,
  SpecialismApi,
  QuizSessionApi,
  SkillCategoryApi,
} from './endpoints';

export class LearningApi extends AbstractApi {
  public quizSession = new QuizSessionApi(this.params);
  public role = new RoleApi(this.params);
  public skillCategory = new SkillCategoryApi(this.params);
  public resource = new ResourceApi(this.params);
  public resourcePaginated = new ResourceApi(this.params);
  public specialism = new SpecialismApi(this.params);
  public manage = new ManageApi(this.params);
}
